module.exports = __webpack_public_path__ + "assets/img/left-hover.a4121dca.svg";